export const pt = {
};